import { Badge } from "flowbite-react";
import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

export default function ConfigHeader() {
  const loginData = useSelector((state) => state.user.loginData);

  return (
    <>
      <div className="config-header">
        <div className="mx-auto flex flex-wrap items-center justify-between">
          <div className="config-header-menu">
            <NavLink
              to="/config-users"
              className={({ isActive }) =>
                isActive ? "config-header-item active" : "config-header-item"
              }
            >
              Users
            </NavLink>

            <NavLink
              to="/configure"
              className={({ isActive }) =>
                isActive ? "config-header-item active" : "config-header-item"
              }
            >
              Advertisers
            </NavLink>
            {loginData?.role === "Admin" && (
              <NavLink
                to="/activity-log"
                className={({ isActive }) =>
                  isActive ? "config-header-item active" : "config-header-item"
                }
              >
                Activity Log
              </NavLink>
            )}
          </div>
          <Badge
            color="gray"
            size="xs"
            className="p-2 px-4 rounded-lg border border-gray-200 bg-gray-50"
          >
            {loginData?.role}
          </Badge>
        </div>
      </div>
    </>
  );
}
